<template>
  <transition name="slide-up">
    <div v-if="showSocialMediaOptions">
      <h4>{{ i18n.t('social:connect_with') }}</h4>
      <div class="items">
        <button id="connect-facebook" v-if="allowFacebookConnect" @click="connect('facebook')" >
          <img class="icon" src="~static/fb_icon.svg" alt="Facebook login"><span v-show="showButtonLabels">Facebook</span>
        </button>
        <button id="connect-google" v-if="allowGoogleConnect" @click="connect('google')" >
          <img class="icon" src="~static/google_icon.svg" alt="Google login"><span v-show="showButtonLabels">Google</span>
        </button>
        <button id="connect-linkedin" v-if="allowLinkedInConnect" @click="connect('linkedin')" >
          <img class="icon" src="~static/linkedin_icon.svg" alt="LinkedIn login"><span v-show="showButtonLabels">LinkedIn</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  div{
    text-align: center;
    font-family: $socialBarFont;
    width: 100%;
    margin: 5px auto;
  }
  h4 {
    text-align: left;
    color: #93989E;
    font-size: 1rem; // 16px
    margin-right: 15px;
  }
  .items {
    display: flex;
    width: calc(100% + 40px);
    margin-left: -20px;
  }
  button{
    text-align: center;
    height: 50px;
    width: 100%;
    margin: auto;
    font-weight: 400;
    font-size: 1rem; // 16px
    color: #505256;
    box-shadow: none;
    background: #F6F7F7;
    border-radius: 5px;
    margin: auto 2px;

    &:first-of-type {
      margin: auto 2px auto 0;
    }
    &:last-of-type {
      margin: auto 0 auto 2px;
    }

    .icon{
      width: 22px;
      height: auto;
      margin: auto auto -5px;
    }

    span {
      margin-left: 10px;
    }
  }
</style>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import { getNestedProperty } from '../utils/structure.js'

export default Vue.component('social-login', {
    data () {
      return {
        showButtonLabels: true
      }
    },
    computed: {
      ...mapState(['app', 'partner', 'socialMediaData']),
      allowFacebookConnect () {
        const isLoggedIn = this.partner.socialMedia.allowOnlyLoggedIn ? this.socialMediaData && this.socialMediaData.facebook && this.socialMediaData.facebook.isLoggedIn : true
        return this.partner.socialMedia && isLoggedIn && this.facebookAppId
      },
      allowGoogleConnect () {
        return this.partner.socialMedia && this.partner.socialMedia.googleId
      },
      allowLinkedInConnect () {
        return this.partner.socialMedia && this.partner.socialMedia.linkedInId && !this.app.deviceIsIOS
      },
      showSocialMediaOptions () {
        const socialMediaAvailable = this.partner.socialMedia.enabled && Object.keys(this.socialMediaData).length !== 0
        const anyOptionActive = this.allowFacebookConnect || this.allowGoogleConnect || this.allowLinkedInConnect

        return socialMediaAvailable && anyOptionActive
      },
      facebookAppId () {
        if (typeof this.partner.socialMedia.facebookAppId === 'object') {
          const labelValue = getNestedProperty(this.$store.state, this.partner.socialMedia.facebookAppId.labelProp)
          const key = labelValue && this.partner.socialMedia.facebookAppId.keys[labelValue]

          return key
        }

        return this.partner.socialMedia.facebookAppId
      }
    },
    watch: {
      showSocialMediaOptions () {
        this.$nextTick(this.buttonLabelsCheck)
      }
    },
    mounted () {
      this.initSocialMedia()
      this.$nextTick(this.buttonLabelsCheck)
    },
    methods: {
      connect (provider) {
        const IDs = this.socialIDs()
        this.$postmate.emit('connectWithSocialMedia', {
          ...IDs,
          provider
        })
      },
      buttonLabelsCheck () {
        if (this.showSocialMediaOptions) {
          const buttons = this.$el.querySelectorAll && this.$el.querySelectorAll('.items button')
          const buttonsCount = buttons && buttons.length
          this.showButtonLabels = buttonsCount && buttonsCount < 3
        }
      },
      initSocialMedia () {
        const IDs = this.socialIDs()
        this.$postmate.emit('initSocialMedia', IDs)
      },
      socialIDs () {
        const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
        const facebookAppId = isLocalhost ? '232452057291525' : this.facebookAppId
        const googleId = isLocalhost ? '485912056311-kcl58g5iufe62bh04osvjgqmh6lripeu.apps.googleusercontent.com' : this.partner.socialMedia.googleId
        const linkedInId = isLocalhost ? '7803pkog06nlor' : this.partner.socialMedia.linkedInId
        return {
          facebookAppId,
          googleId,
          linkedInId
        }
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/SocialLogin.vue